import './AutoMessage.scss'
import React from 'react'
import { observer } from 'mobx-react'
import { channelStore } from '../../app/stores'
import AutoMessageForm from './AutoMessageForm'
import { Icon, Button, UserAvatar, mapValues } from '../../lib'
import { TRIGGER_TYPES } from '../../app/constants'

const AutoMessageMeta = ({ type, wait, match, path, views }) => {
  switch (Number(type)) {
    case TRIGGER_TYPES.TIME_ON_PAGE:
      return (
        <span className='AutoMessage_meta'>
          <Icon name='clock' /> Time on page is {wait}s
        </span>
      )
    case TRIGGER_TYPES.PAGE_VIEWS:
      return (
        <span className='AutoMessage_meta'>
          <Icon name='world' /> Page views is {views}
        </span>
      )
    case TRIGGER_TYPES.MATCH_URL:
      return (
        <span className='AutoMessage_meta'>
          <Icon name='world' /> Current url is {path}
        </span>
      )
    default:
      return null
  }
}

const onDelete = (key) => {
  if (window.confirm('Are you sure you want to delete this auto message?')) { channelStore.removeAutoMessage(key) }
}

const AutoMessage = ({ editing, autoMessage, onClose, onEdit }) => {
  if (editing) {
    return (
      <AutoMessageForm
        fieldValues={autoMessage}
        onSubmit={fieldsData => {
          const values = mapValues(fieldsData)
          return channelStore.editAutoMessage(autoMessage.key, values)
        }}
        onSubmitSuccess={onClose}
        onClose={onClose}
        prompt='Save'
      />
    )
  } else {
    return (
      <div className='AutoMessage'>
        <UserAvatar size={30} />
        <div className='AutoMessage_info'>
          <h4>{autoMessage.message}</h4>
          <AutoMessageMeta {...autoMessage} />
        </div>
        <div className='AutoMessage_controls'>
          <Button styleType='text' onClick={() => onEdit(autoMessage.key)}>
            <Icon name='edit' />
          </Button>
          <Button styleType='text' onClick={() => onDelete(autoMessage.key)}>
            <Icon name='trash' />
          </Button>
        </div>
      </div>
    )
  }
}

export default observer(AutoMessage)



// WEBPACK FOOTER //
// ./src/channel/automessages/AutoMessage.js